// CyberOne paid-order device registration v2026-07-10b
$(document).ready(function() {
  var DEVICE_FIELDS = ["First Name", "Last Name", "Email", "Phone"];

  $(document).on("click", ".custom_add-to-cart .itg_button", function() {
    setupMultiDeviceForm();
    $(".cyber_form_wrap").addClass("show");
  });

  $(document).on("click", ".form-container .itg_close_btn", function() {
    $(".cyber_form_wrap").removeClass("show");
  });

  $("#single_product_form").submit(function(event) {
    event.preventDefault();

    var device = {
      firstName: $(".single-product-popup #first-name").val(),
      lastName: $(".single-product-popup #last-name").val(),
      email: $(".single-product-popup #FormEmail").val(),
      phone: $(".single-product-popup #telnumber").val()
    };

    setDeviceProperties(1, device);
    setPropertyInput("pro_address", "Address", $(".single-product-popup #address").val());
    $("#single_form_submit").val("Wait..");
    submitCartForm();
    $(".cyber_form_wrap").removeClass("show");
  });

  $("#multi_product_form").submit(function(event) {
    event.preventDefault();
    setupMultiDeviceForm();

    var devices = collectMultiDevices();
    if (!devices.valid) {
      showFormError($("#multi_product_form"), devices.error);
      return;
    }

    clearDeviceProperties();
    devices.items.forEach(function(device, index) {
      setDeviceProperties(index + 1, device);
    });

    setPropertyInput("pro_address", "Address", $(".multi-product-popup #address").val());
    $("#multi_form_submit").val("Wait..");
    submitCartForm();
    $(".cyber_form_wrap").removeClass("show");
  });

  function setupMultiDeviceForm() {
    var $form = $("#multi_product_form");
    if (!$form.length || $form.data("cyberone-device-setup")) {
      return;
    }

    $form.data("cyberone-device-setup", true);
    $form.find(".cyberone-form-error").remove();

    $("#first-name").attr({
      id: "device-1-first-name",
      name: "device-1-first-name",
      placeholder: "Device 1 First Name",
      required: true
    });
    $("#last-name").attr({
      id: "device-1-last-name",
      name: "device-1-last-name",
      placeholder: "Device 1 Last Name",
      required: true
    });
    $("#FormEmail").attr({
      id: "device-1-email",
      name: "device-1-email",
      placeholder: "Device 1 Email",
      required: true
    });
    $("#telnumber-1").attr({
      id: "device-1-phone",
      name: "device-1-phone",
      placeholder: "Device 1 Mobile Number",
      required: true
    }).removeAttr("maxlength pattern");

    $("#telnumber-2, #telnumber-3, #telnumber-4").closest(".form_input").remove();

    var $addressInput = $(".multi-product-popup #address").closest(".form_input");
    for (var deviceNumber = 2; deviceNumber <= 4; deviceNumber++) {
      $addressInput.before(buildOptionalDeviceBlock(deviceNumber));
    }
  }

  function buildOptionalDeviceBlock(deviceNumber) {
    return [
      '<div class="cyberone-device-block" data-device="' + deviceNumber + '">',
      '<div><label>Device ' + deviceNumber + ' details</label></div>',
      '<div class="form_input"><input type="text" id="device-' + deviceNumber + '-first-name" name="device-' + deviceNumber + '-first-name" placeholder="Device ' + deviceNumber + ' First Name" value=""></div>',
      '<div class="form_input"><input type="text" id="device-' + deviceNumber + '-last-name" name="device-' + deviceNumber + '-last-name" placeholder="Device ' + deviceNumber + ' Last Name" value=""></div>',
      '<div class="form_input"><input type="email" id="device-' + deviceNumber + '-email" name="device-' + deviceNumber + '-email" placeholder="Device ' + deviceNumber + ' Email" value=""></div>',
      '<div class="form_input"><input type="tel" id="device-' + deviceNumber + '-phone" name="device-' + deviceNumber + '-phone" placeholder="Device ' + deviceNumber + ' Mobile Number" value=""></div>',
      '</div>'
    ].join("");
  }

  function collectMultiDevices() {
    var devices = [];
    var emails = {};

    for (var deviceNumber = 1; deviceNumber <= 4; deviceNumber++) {
      var device = getMultiDevice(deviceNumber);
      var hasAnyValue = Boolean(device.firstName || device.lastName || device.email || device.phone);
      var isRequired = deviceNumber === 1;

      if (!isRequired && !hasAnyValue) {
        continue;
      }

      if (!device.firstName || !device.lastName || !device.email || !device.phone) {
        return {
          valid: false,
          error: "Please complete first name, last name, email, and mobile number for Device " + deviceNumber + "."
        };
      }

      if (!isValidEmail(device.email)) {
        return {
          valid: false,
          error: "Please enter a valid email for Device " + deviceNumber + "."
        };
      }

      var normalizedEmail = device.email.toLowerCase();
      if (emails[normalizedEmail]) {
        return {
          valid: false,
          error: "Each device needs a unique email address."
        };
      }

      emails[normalizedEmail] = true;
      devices.push(device);
    }

    return {
      valid: true,
      items: devices
    };
  }

  function getMultiDevice(deviceNumber) {
    return {
      firstName: $("#device-" + deviceNumber + "-first-name").val(),
      lastName: $("#device-" + deviceNumber + "-last-name").val(),
      email: $("#device-" + deviceNumber + "-email").val(),
      phone: $("#device-" + deviceNumber + "-phone").val()
    };
  }

  function clearDeviceProperties() {
    for (var deviceNumber = 1; deviceNumber <= 4; deviceNumber++) {
      DEVICE_FIELDS.forEach(function(fieldName) {
        setPropertyInput(deviceInputId(deviceNumber, fieldName), "Device " + deviceNumber + " " + fieldName, "");
      });
    }
  }

  function setDeviceProperties(deviceNumber, device) {
    setPropertyInput(deviceInputId(deviceNumber, "First Name"), "Device " + deviceNumber + " First Name", device.firstName);
    setPropertyInput(deviceInputId(deviceNumber, "Last Name"), "Device " + deviceNumber + " Last Name", device.lastName);
    setPropertyInput(deviceInputId(deviceNumber, "Email"), "Device " + deviceNumber + " Email", device.email);
    setPropertyInput(deviceInputId(deviceNumber, "Phone"), "Device " + deviceNumber + " Phone", device.phone);
  }

  function setPropertyInput(id, propertyName, value) {
    var $form = $("form[action='/cart/add']").first();
    var $input = $("#" + id);

    if (!$input.length) {
      $input = $("<input>", {
        type: "hidden",
        id: id
      }).appendTo($form);
    }

    $input.attr("name", "properties[" + propertyName + "]").val(value || "");
  }

  function submitCartForm() {
    var form = $("form[action='/cart/add']").get(0);
    if (!form) {
      return;
    }

    $(form).find("input[name='id']").prop("disabled", false);

    if (form.requestSubmit) {
      form.requestSubmit();
      return;
    }

    var addButton = $("#AddToCart").get(0);
    if (addButton && addButton.click) {
      addButton.click();
      return;
    }

    form.submit();
  }

  function deviceInputId(deviceNumber, fieldName) {
    return "cyberone_device_" + deviceNumber + "_" + fieldName.toLowerCase().replace(/\s+/g, "_");
  }

  function showFormError($form, message) {
    var $error = $form.find(".cyberone-form-error");
    if (!$error.length) {
      $error = $('<div class="cyberone-form-error" style="color:#c62a32;margin:0 0 12px;"></div>');
      $form.prepend($error);
    }
    $error.text(message);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }
});
